import { createContext } from "react";

export const SizeContext = createContext();
